import React from 'react'
import { Note } from '../_components/Notes/Note'
import { FaLink } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import ROUTES from '../_constants/routes'

export const AccountingConnectButton = ({ isConnectedToAccountingPlatform = false, accountingPlatform = '' }) => {
  return (
    <div>
      {isConnectedToAccountingPlatform ? (
        <Note icon={FaLink} message={<p>You’re connected with {accountingPlatform}.</p>} />
      ) : (
        <Note
          icon={FaLink}
          message={
            <p>
              You have not connected your accounting platform.
              <Link to={ROUTES.accounting_platforms}>Click here</Link> to pull your invoices automatically.
            </p>
          }
        />
      )}
    </div>
  )
}
